import { createContext, useContext } from "react";
import { type PageContext } from "vike/types";

type PageContextProviderProps = {
  pageContext: PageContext;
  children: React.ReactNode;
};

const Context = createContext<PageContext | undefined>(undefined);

export const PageContextProvider = function ({
  pageContext,
  children,
}: PageContextProviderProps) {
  return <Context.Provider value={pageContext}>{children}</Context.Provider>;
};

type RouteMatch = {
  pageId: string;
  routeParams: Record<string, string>;
  routeString: string;
  routeType: "FILESYSTEM";
};

export function usePageContext(): PageContext & {
  _routeMatch?: RouteMatch; // it is provided by vike but not is in original type
} {
  const pageContext = useContext(Context);
  if (!pageContext) {
    throw new Error("usePageContext must be used within a PageContextProvider");
  }
  return pageContext;
}
